import { Button } from '@mc/design-system'
import { useTranslation } from '@mc/i18n'
import { paths } from '@mc/paths'
import type { GrowthCategory } from '@mc/api'

import type { Subcat } from '../../dataFetching'
import { trackViewAllClick } from '../../events'

interface TNavCta {
  category: GrowthCategory
  subcat?: Subcat
}

export const NavCta = ({ category, subcat }: TNavCta) => {
  const { t } = useTranslation('@mc/next')

  const ctaHref = paths.subcategoryPage(subcat?.slug)
  const viewAllCount = subcat?.courses.length

  const onClick = () => {
    trackViewAllClick({
      catName: category.name,
      subcatName: subcat?.name || null,
      actionCta: `View All Classes_${viewAllCount ?? 0}`,
    })
  }

  return (
    <Button
      as='a'
      kind='tertiary'
      fullWidth
      href={ctaHref}
      onClick={onClick}
      loading={!viewAllCount}
    >
      {t('nav.cta.viewAll', { count: viewAllCount ?? 0 })}
    </Button>
  )
}
